import classNames from "classnames";

/** Loader Component */
export const Loader = ({
  className,
  size = "md",
  loading,
  variant,
  ...rest
}: LoaderProps) => {
  if (!loading) return null;
  return (
    <div
      data-testid="loader"
      className={classNames(
        "animate-spin rounded-full border-b-transparent",
        {
          "h-4 min-h-4 w-4 min-w-4 border-2": size === "sm",
          "h-8 min-h-8 w-8 min-w-8 border-4": size === "md",
          "h-12 min-h-12 w-12 min-w-12 border-6": size === "lg",
          "border-primary": variant === "primary",
          "border-secondary": variant === "secondary",
        },
        className,
      )}
      data-size={size}
      {...rest}></div>
  );
};

export type LoaderProps = {
  /** Class overrides */
  className?: string;
  /** Show loading indicator */
  loading?: boolean;
  /** Disable button */
  size?: LoaderSizeProps;
  variant?: "primary" | "secondary";
};

export type LoaderSizeProps = "sm" | "md" | "lg";
